import { ENV_MODE, REGION_MODE } from './config';
const config = {
  test: {
    cn: {
      serverUrl: 'https://snssdk.ninebot.com',
      appId: 10000003
    },
    us: {
      serverUrl: 'https://snssdk-eu.ninebot.com',
      appId: 10000002
    }
  },
  grey: {
    cn: {
      serverUrl: 'https://snssdk.ninebot.com',
      appId: 10000003
    },
    us: {
      serverUrl: 'https://snssdk-eu.ninebot.com',
      appId: 10000002
    }
  },
  prod: {
    cn: {
      serverUrl: 'https://snssdk.ninebot.com',
      appId: 10000005
    },
    us: {
      serverUrl: 'https://snssdk-eu.ninebot.com',
      appId: 10000004
    }
  }
};
export function initByte(platform: string, customParams?: any) {
  if (process.client) {
    const { serverUrl, appId } = config[ENV_MODE][REGION_MODE];
    const hm = document.createElement('script');
    hm.src = `${serverUrl}/minio.byterangers.onpremise.docor.static/collect-privity-v5.2.6.js`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);

    (function (win, export_obj) {
      win['TeaAnalyticsObject'] = export_obj;
      if (!win[export_obj]) {
        function _collect() {
          _collect.q.push(arguments);
        }
        _collect.q = _collect.q || [];
        win[export_obj] = _collect;
      }
      win[export_obj].l = +new Date();
    })(window, 'collectEvent');

    window.collectEvent('init', {
      app_id: appId,
      channel_domain: serverUrl, // 替换为私有部署部署服务地址,
      enable_native: true, // H5内嵌到原生端并打通
      disable_sdk_monitor: true, //用于禁止SDK启动后自身监控事件 onload 的上报
      autotrack: true, // 全埋点
      log: true,
      enable_debug: ENV_MODE === 'test' || ENV_MODE === 'grey', // 是否开启调试模式
    });

    // 公共属性
    const { app_uid, app_version, vehicle_sn, language, url_source, country } =
      customParams;

    window.collectEvent('config', {
      time: Date.now(),
      tracking_version: '1.0.1',
      service_platform: platform,
      _track_id: Math.random().toString(36).substr(3, 10),
      env: ENV_MODE == 'prod' ? 1 : 2,
      access_country: country,
      url_source
    });

    typeof app_uid !== 'undefined' &&
      window.collectEvent('config', {
        app_uid: app_uid
      });

    typeof app_version !== 'undefined' &&
      window.collectEvent('config', {
        app_version_name: app_version
      });

    typeof vehicle_sn !== 'undefined' &&
      window.collectEvent('config', {
        vehicle_sn: vehicle_sn
      });
    typeof language !== 'undefined' &&
      window.collectEvent('config', {
        user_language: language
      });

    window.collectEvent('start');
  }
}
